export const LAST_SCANNED_BARCODE = 'last_scanned_barcode';
